import Axios from "axios";
import { getClipTitle } from "../Utilities/Clip";
import { getClient } from "../Utilities/statsigClient";

declare global {
  interface Window {
    rudderanalytics: any;
    clarity: any;
  }
}

const getItem = (key: string) => {
  const data = localStorage.getItem(key);
  if (!data) return null;
  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
};

const track = (
  event: string,
  properties: Record<string, unknown> = {},
): void => {
  const statsigClient = getClient();
  window.rudderanalytics.track(event, {
    ...properties,
    statsigCustomIDs: ["stableID", statsigClient?.getContext()?.stableID],
  });
};

const identify = (userId: string, traits?: Record<string, unknown>): void => {
  window.rudderanalytics.identify(userId, { ...traits });
};

const page = (event: string, properties: Record<string, unknown>): void => {
  const statsigClient = getClient();
  window.rudderanalytics.page(event, {
    ...properties,
    statsigCustomIDs: ["stableID", statsigClient?.getContext()?.stableID],
  });
};

export const analytics = {
  track,
  identify,
  page,
};

// Deprecated: Prefer using non-default export
export default {
  track,
  page: (page: string): void => {
    window.rudderanalytics.page(page);
  },
  identify,
  updateTraits(traits?: Record<string, unknown>) {
    const state = getItem("allstar-state");

    const userId = state?.userData?.decoded?._id;

    if (userId) {
      window.rudderanalytics.identify(userId, traits);
      return;
    } else {
      window.rudderanalytics.identify(traits);
    }
  },
};

export const trackClipSocialShare = ({
  platform,
  handler,
  clip,
  queue,
  data,
  aspectRatio,
}: any) => {
  analytics.track("Clip Shared", {
    clipID: clip.internalId || clip._id,
    game: clip.game,
    tags: clip.clipProperties,
    length: clip.clipLength,
    clipOwner: clip.user?._id,
    shareDestination: platform,
    shareId: clip?.shareId,
  });

  const analyticsProperties = {
    clipName: getClipTitle(clip),
    game: clip.game,
    tags: clip.clipProperties,
    length: clip.clipLength,
    total_reactions: clip.totalReactions,
    total_views: clip.views,
    shareDestination: platform,
    shareId: clip?.shareId,
  };

  const uploadPlatforms = ["YouTube", "TikTok"];

  if (handler && uploadPlatforms.includes(platform)) {
    const baseUrl = process.env.REACT_APP_API_URL;

    handler({
      method: "POST",
      url: `${baseUrl}/items/clip/upload${queue === true ? "?queue=true" : ""}`,
      data: {
        _id: clip.internalId || clip._id,
        platform,
        data,
        aspectRatio,
        analytics: analyticsProperties,
      },
    });
  } else {
    postApiSegment({
      event: "Creator - Clip Shared",
      userId: clip.user?._id,
      properties: analyticsProperties,
    });
  }
};

export const trackCreatorCardShare = (card: any) => {
  analytics.track("Creator Card Shared", {
    cardId: card._id,
    badge: card.ui.badge,
    category: card.ui.category,
    cost: card.ui.cost,
    rarity: card.ui.rarity,
    uses: card.ui.uses,
    useType: card.ui.useType,
  });
};

export async function postApiSegment(data: any) {
  const opt: any = {
    method: "POST",
    url: `${process.env.REACT_APP_API_URL}/analytics/segment`,
    data: data,
  };
  try {
    return Axios(opt);
  } catch (e: any) {
    return e.response;
  }
}
